"use client";

import { ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Approccio() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const features = [{
    number: "01",
    title: "Diagnostica Avanzata",
    description: "Utilizziamo protocolli diagnostici di ultima generazione per analizzare la fisiopatologia della riproduzione umana, garantendo precisione clinica e un approccio personalizzato per ogni percorso di fertilità."
  }, {
    number: "02",
    title: "Ostetricia Specialistica",
    description: "Monitoraggio costante e attento durante tutto il periodo gestazionale, con un focus particolare sulla salute della madre e del feto, integrando le migliori pratiche della medicina ostetrica moderna."
  }, {
    number: "03",
    title: "Consulenza Forense",
    description: "Supporto medico-legale esperto in ambito ginecologico e ostetrico, offrendo perizie tecniche e valutazioni basate su evidenze scientifiche rigorose per la tutela dei diritti in sede giudiziaria."
  }, {
    number: "04",
    title: "Percorsi Personalizzati",
    description: "Ogni paziente riceve un piano di cura su misura, frutto di un'analisi multidisciplinare che unisce competenza chirurgica, sensibilità umana e rigore scientifico per risultati d'eccellenza."
  }];
  return <section data-section-id="5077" id="lapproccio-scientifico" className="bg-background text-foreground py-24 md:py-40 px-6 md:px-12 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-20 md:mb-32 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="md:col-span-4 flex flex-col">
            <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
              03 // Metodologia
            </span>
            <div className="mt-6 w-px h-24 md:h-32" style={{
            backgroundColor: "var(--primary)"
          }} aria-hidden="true" />
          </div>

          {}
          <div className="md:col-span-8">
            <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[80px] leading-[1.05]" style={{
            letterSpacing: "-0.03em"
          }}>
              L'Approccio{" "}
              <span style={{
              color: "var(--primary)"
            }}>Scientifico</span> al{" "}
              <span style={{
              color: "var(--primary)"
            }}>Benessere</span>.
            </h2>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-12">
          {features.map((feature, i) => {
          return <FeatureBlock key={feature.number} data-index={i} number={feature.number} title={feature.title} description={feature.description} delay={i * 120} />;
        })}
        </div>
      </div>
    </section>;
}
function FeatureBlock({
  number,
  title,
  description,
  delay,
  ...rest
}: {
  number: string;
  title: string;
  description: string;
  delay: number;
  [key: string]: unknown;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <div ref={ref} className={`relative flex flex-col transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    transitionDelay: `${delay}ms`
  }} {...rest}>
      {}
      <span className="font-mono text-3xl md:text-4xl font-medium leading-none" style={{
      color: "var(--primary)"
    }}>
        {number}
      </span>

      {}
      <div className="mt-6 h-px w-full" style={{
      backgroundColor: "var(--border)"
    }} aria-hidden="true" />

      {}
      <h3 className="font-default font-semibold text-2xl md:text-3xl mt-8 leading-tight tracking-tight">
        {title}
      </h3>

      {}
      <p className="font-default text-base md:text-[17px] mt-5 text-muted-foreground" style={{
      lineHeight: 1.7,
      maxWidth: "420px"
    }}>
        {description}
      </p>

      {}
      <div className="mt-8 flex justify-end">
        <ChevronRight className="size-6 stroke-[1.25]" style={{
        color: "var(--primary)"
      }} aria-hidden="true" />
      </div>
    </div>;
}